import { Modals } from '@/constants';

import { AppModal } from '../AppModal';
import { SignupModalContent } from './SignupModalContent';

export const SignupModal = () => {
  return (
    <AppModal
      modalName={Modals.SIGN_UP}
      transparentBackground
      disableRestoreFocus>
      <SignupModalContent />
    </AppModal>
  );
};
